var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loadingDetails
        ? _c("application-standalone-loader", { attrs: { rows: 5 } })
        : _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-row",
                { staticClass: "my-5", attrs: { "no-gutters": "" } },
                [
                  _c("p", { staticClass: "description-client m-0" }, [
                    !_vm.showForm
                      ? _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "account.registration.pageSubtitleClient"
                                )
                              ) +
                              "\n          "
                          ),
                          _c("br"),
                        ])
                      : _vm._e(),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("account.registration.alreadyHaveAnAccount")
                        ) +
                        "  \n        "
                    ),
                    _c("a", { attrs: { href: "#/login" } }, [
                      _vm._v(_vm._s(_vm.$t("account.registration.loginHere"))),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              !_vm.showForm
                ? _c(
                    "b-row",
                    { attrs: { tag: "article" } },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("text-field", {
                            staticClass: "text-input",
                            attrs: {
                              id: "email-signup",
                              value: _vm.formData.email,
                              label: _vm.$t("account.enterEmail"),
                              placeholder: _vm.$t("account.email"),
                              "input-type": "email",
                              validator: _vm.v$.formData.email,
                              "on-type": "",
                              "client-login": "",
                            },
                            on: {
                              "update:value": function ($event) {
                                return _vm.$set(_vm.formData, "email", $event)
                              },
                              enter: _vm.handleCheckEmail,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass:
                            "app-flow-buttons mt-3 justify-content-center d-flex",
                        },
                        [
                          _c(
                            "simple-button",
                            {
                              attrs: {
                                id: "btn-next",
                                disabled: !_vm.isEmailValid,
                                "class-name": "py-2 px-5 rounded-pill",
                                loading: _vm.loadingCheckEmail,
                                "loading-succeeded":
                                  _vm.loadingStatusCheckEmail,
                              },
                              on: { click: _vm.handleCheckEmail },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("global.words.next")) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "b-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            { attrs: { id: "name-section" } },
                            [
                              _c(
                                "b-row",
                                { attrs: { tag: "article" } },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c("text-field", {
                                        staticClass: "text-input",
                                        attrs: {
                                          id: "first-name",
                                          value: _vm.formData.givenName,
                                          placeholder:
                                            _vm.$t("account.givenName"),
                                          label: _vm.$t("account.givenName"),
                                          validator: _vm.v$.formData.givenName,
                                          "client-login": "",
                                        },
                                        on: {
                                          "update:value": function ($event) {
                                            return _vm.$set(
                                              _vm.formData,
                                              "givenName",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c("text-field", {
                                        staticClass: "text-input",
                                        attrs: {
                                          id: "last-name",
                                          value: _vm.formData.familyName,
                                          placeholder:
                                            _vm.$t("account.familyName"),
                                          label: _vm.$t("account.familyName"),
                                          validator: _vm.v$.formData.familyName,
                                          "client-login": "",
                                        },
                                        on: {
                                          "update:value": function ($event) {
                                            return _vm.$set(
                                              _vm.formData,
                                              "familyName",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { attrs: { id: "contact-section" } },
                            [
                              _c(
                                "b-row",
                                { attrs: { tag: "article" } },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c("text-field", {
                                        staticClass: "text-input",
                                        attrs: {
                                          id: "email-client",
                                          value: _vm.formData.email,
                                          disabled: "",
                                          "input-type": "email",
                                          placeholder: _vm.$t("account.email"),
                                          label: _vm.$t("account.email"),
                                          validator: _vm.v$.formData.email,
                                          "client-login": "",
                                        },
                                        on: {
                                          "update:value": function ($event) {
                                            return _vm.$set(
                                              _vm.formData,
                                              "email",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c("text-field", {
                                        staticClass: "text-input",
                                        attrs: {
                                          id: "phone-no",
                                          value: _vm.formData.phoneNumber,
                                          placeholder: _vm.$t(
                                            "account.phoneNumber"
                                          ),
                                          label: _vm.$t("account.phoneNumber"),
                                          "mask-type": "phone",
                                          "client-login": "",
                                        },
                                        on: {
                                          "update:value": function ($event) {
                                            return _vm.$set(
                                              _vm.formData,
                                              "phoneNumber",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { attrs: { tag: "article" } },
                            [
                              _c(
                                "b-col",
                                {
                                  attrs: {
                                    id: "time-zone",
                                    cols: "12",
                                    md: "6",
                                  },
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(_vm.$t("account.currentTimezone"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("timezone-select", {
                                    attrs: {
                                      id: "timezone-select",
                                      timezone: _vm.formData.timezone,
                                    },
                                    on: {
                                      "update:timezone": function ($event) {
                                        return _vm.$set(
                                          _vm.formData,
                                          "timezone",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { attrs: { id: "password-section" } },
                            [
                              _c(
                                "b-row",
                                { attrs: { tag: "article" } },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("account.choosePassword")
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("rules-password-input", {
                                        attrs: {
                                          id: "password",
                                          password: _vm.formData.password,
                                        },
                                        on: {
                                          "update:password": function ($event) {
                                            return _vm.$set(
                                              _vm.formData,
                                              "password",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("account.reEnterPassword")
                                          ) + " "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("password-input", {
                                        attrs: {
                                          id: "password",
                                          "signup-client": true,
                                          password: _vm.formData.passwordRepeat,
                                          "validator-context":
                                            _vm.v$.formData.passwordRepeat,
                                          placeholder: _vm.$t(
                                            "account.reEnterPassword"
                                          ),
                                          "input-type": "password",
                                        },
                                        on: {
                                          "update:password": function ($event) {
                                            return _vm.$set(
                                              _vm.formData,
                                              "passwordRepeat",
                                              $event
                                            )
                                          },
                                          blur: _vm.handleMatchInputBlur,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            {
                              staticClass: "no-gutters justify-content-center",
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "mb-sm-0 mb-3 text-center pretty-regular",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "required pretty p-icon p-smooth p-bigger",
                                      staticStyle: {
                                        "margin-top": "15px",
                                        "margin-bottom": "20px",
                                        "margin-right": "2px",
                                      },
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.terms,
                                            expression: "terms",
                                          },
                                        ],
                                        staticClass: "checkbox",
                                        attrs: {
                                          id: "terms",
                                          type: "checkbox",
                                        },
                                        domProps: {
                                          checked: Array.isArray(_vm.terms)
                                            ? _vm._i(_vm.terms, null) > -1
                                            : _vm.terms,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.terms,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.terms = $$a.concat([
                                                    $$v,
                                                  ]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.terms = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.terms = $$c
                                            }
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "state p-primary" },
                                        [
                                          _c(
                                            "i",
                                            {
                                              staticClass:
                                                "icon material-icons",
                                            },
                                            [_vm._v("done")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "text-light-gray",
                                              attrs: { for: "terms" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "account.form.youAgreeTo"
                                                  )
                                                ) + "\n                  "
                                              ),
                                              !_vm.isFrenchLanguage
                                                ? _c("span", [
                                                    _vm._v(" Expert Pro’s"),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "terms clickable text-primary",
                                      attrs: {
                                        href: _vm.tosExternalLink,
                                        target: "_blank",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("global.doorr.tos")))]
                                  ),
                                  _vm._v(" "),
                                  _vm.isFrenchLanguage
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("account.form.ofExpertPro")
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass:
                            "app-flow-buttons mt-3 justify-content-center d-flex",
                        },
                        [
                          _c(
                            "simple-button",
                            {
                              attrs: {
                                id: "create-account",
                                disabled: !_vm.isValid,
                                "class-name": "py-2 px-5 rounded-pill",
                                loading: _vm.loading,
                                "loading-succeeded": _vm.loadingStatus,
                              },
                              on: { click: _vm.handleSubmit },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("account.createAccount")) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }